import * as React from 'react';
import cn from '~modules/cn';

import './badge.scss';

type Props = {
    text: React.ReactNode;
    type?: 'default' | 'upgrade';
    badgeSize?: BadgeSize;
    icon?: React.ReactNode;
    className?: string;
};

export type BadgeSize = 'medium' | 'small';

const Badge = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
    const { type = 'default', badgeSize = 'medium' } = props;
    return (
        <div
            ref={ref}
            className={cn(
                'badge',
                `badge--type-${type}`,
                {
                    [`badge--size-${badgeSize}`]: badgeSize
                },
                props.className
            )}
        >
            {props.icon && <div className="badge__icon">{props.icon}</div>}
            {props.text}
        </div>
    );
});
Badge.displayName = 'Badge';

export default Badge;
